import {queryOptions} from "@tanstack/react-query"

import {fetch} from '../services/ProductsService'

export const createProductQueryOptions = (productId: string) => {

    const queryKey = 'product'

    return queryOptions(
        {
            queryKey: [queryKey, productId],
            queryFn: () => fetch(productId),
            enabled: !!productId
        })

}